/* eslint-disable camelcase */
type Locale = 'en' | 'es';
type Phrase = (l: Locale) => string;

export const i18n_want_to_watch_series: Phrase = locale => {
  const phrases: { [key: string]: undefined | string } = {
    en: `Want to stream our content on yogic wisdom?`,
    es: `¿Quieres ver en streaming nuestro contenido sobre sabiduría yóguica?`,
  };
  return phrases[locale] || phrases.en || ``;
};
